<template>
    <div class="admin-sidebar">
        <AdminSidebarSection
            v-for="(section,index) in navigation"
            :key="'sidebar-item-' + index"
            :section="section"
        />


        <div class="admin-sidebar-section">
            <div
                class="admin-sidebar-section__button admin-sidebar-section__button--icon admin-sidebar-section__button--administration"
                @click="assetLibraryClick"
            >
                <i class="fa fa-clone"/>
                <span>Asset library</span>
            </div>
        </div>


        <div class="admin-sidebar__os">
            <p>
                &copy; {{ new Date().getFullYear() }} Columns.<br/>
            </p>
        </div>

        <teleport to="body">
            <AssetLibrary
                v-if="pickAsset"
                @close="closeAssetLibrary"
            />
        </teleport>
    </div>
</template>

<script>
import AdminSidebarSection from "./partials/AdminSidebarSection";
import AssetLibrary from '../asset-library/AssetLibrary';

export default {
    components: {
        AdminSidebarSection,
        AssetLibrary
    },

    methods: {
        assetLibraryClick() {
            this.pickAsset = true;
        },

        closeAssetLibrary() {
            this.pickAsset = false;
        }
    },

    data() {
        return {
            value: null,
            pickAsset: false,
            navigation: [
                {
                    id: 1,
                    title: 'General Content',
                    key: 'general',
                    hasSectionHomepage: false,
                    hasSectionPages: false,
                    items: [
                        {
                            title: 'Website homepage',
                            link: {
                                name: 'admin-resource',
                                params: {
                                    type: 'pages',
                                },
                                query: {
                                    section: 'home',
                                    sectionHomepage: true,
                                    ignoreParent: true,
                                    sectionTitle: 'Homepage',
                                },
                            },
                        },
                        {
                            title: 'General pages',
                            link: {
                                name: 'admin-resource',
                                params: {
                                    type: 'pages',
                                },
                                query: {
                                    section: 'general',
                                    ignoreParent: true,
                                    sectionTitle: 'General/Landing pages',
                                },
                            },
                        },
                        {
                            title: 'Footer pages',
                            link: {
                                name: 'admin-resource',
                                params: {
                                    type: 'pages',
                                },
                                query: {
                                    section: 'footer',
                                    ignoreParent: true,
                                    sectionTitle: 'Footer pages',
                                },
                            },
                        },
                    ],
                },
                {
                    id: 2,
                    title: 'About Us',
                    key: 'about',
                    hasSectionHomepage: true,
                    hasSectionPages: true,
                    items: [],
                },
                {
                    id: 3,
                    title: 'Services',
                    key: 'services',
                    hasSectionHomepage: true,
                    hasSectionPages: true,
                    items: [],
                },
                {
                    id: 4,
                    title: 'News and views',
                    key: 'news-and-views',
                    hasSectionHomepage: true,
                    hasSectionPages: false,
                    items: [],
                },
                {
                    id: 5,
                    title: 'Research',
                    key: 'research',
                    hasSectionHomepage: true,
                    hasSectionPages: false,
                    items: [],
                },
                {
                    id: 6,
                    title: 'Clients',
                    key: 'clients',
                    hasSectionHomepage: true,
                    hasSectionPages: false,
                    items: [],
                },
                {
                    id: 7,
                    title: 'Contact',
                    key: 'contact',
                    hasSectionHomepage: true,
                    hasSectionPages: false,
                    items: [],
                },
                {
                    id: 8,
                    title: 'Administration',
                    key: 'administration',
                    hasSectionHomepage: false,
                    hasSectionPages: false,
                    admin: true,
                    icon: 'cog',
                    items: [],
                },
            ],
        }
    },
}
</script>

<style>
.admin-sidebar {
    &__os {
        @apply text-sm font-sofia-pro font-normal text-silver mt-8;

        p {
            @apply m-0 p-0 leading-relaxed;
        }
    }
}
</style>
